module.exports = __webpack_public_path__ + "assets/media/client-4.a438ff20.svg";